import { AllOrdersContext } from "../../context/AllOrdersContext"
import { useContext } from "react"

export const useAllOrdersContext = () => {
  const context = useContext(AllOrdersContext)

  if(!context) {
    throw Error('useAllOrdersContext must be used inside an AllOrdersContextProvider')
  }

  return context
}